import styled from 'styled-components';

import AssignAgentModal from './container';

export default styled(AssignAgentModal)`
  position: relative;
  .loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    z-index: 4;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
